export default __webpack_public_path__ + "b1cad4c9dc1e9632bc637798d48967c4.png";